import React, { useState, useEffect, useCallback, useMemo } from 'react';
import styled from 'styled-components';
import { useLocation, useHistory } from 'react-router-dom';

// import { isMobile } from 'react-device-detect';
import Layout from 'antd/es/layout';

// import userRole from 'config/userRole';
// import useAuth from 'hooks/useAuth';
import useMainMenu from 'hooks/useMainMenu';

// import NotificationToaster from 'components/notifications/NotificationToaster';

import SideNav from './components/SideNav';
import useResource from 'hooks/useResource';
import { ResourceType } from 'services/resources';
// import { GenAgentChat } from 'genassist-chat-react';
import { useFeatureToggleItem } from 'components/FeatureToggle';
import featureToggles from 'config/featureToggles';
import usePageTitle from 'hooks/usePageTitle';

const BaseLayout = styled(Layout)`
  height: 100vh;
  background-color: #fff;

  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

const Sider = styled(Layout.Sider)`
  padding: 0;
  height: 100vh;
`;

const Content = styled(Layout.Content)`
  padding-right: 8px;
  padding-left: 1px;
  overflow-y: overlay;
`;

const PrimaryLayout = ({ children, showNotifications = true }) => {
  // const { state: auth } = useAuth();
  const location = useLocation();
  const history = useHistory();
  const mainMenu = useMainMenu();
  const [isLoading, setIsLoading] = useState(true);
  const [currentPathKey, setCurrentPathKey] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const chatIsVisible = useFeatureToggleItem(featureToggles.CHAT)?.visible;
  const { state: locationsState } = useResource(ResourceType.locations, {
    prefetch: true,
  });

  const locationInfo = useMemo(() => {
    return locationsState.list[0] && !locationsState.isLoading ? locationsState.list[0] : null;
  }, [locationsState])

  // eslint-disable-next-line no-unused-vars
  const chatMetadata = useMemo(() => {
    if (!locationInfo) return undefined;
    const locationId = locationInfo.location_id ?? locationInfo.id ?? locationInfo.locationId;
    const locationName = locationInfo.location_name ?? locationInfo.name ?? locationInfo.locationName;
    if (typeof locationId === 'undefined' && typeof locationName === 'undefined') return undefined;
    return {
      ...(typeof locationId !== 'undefined' ? { location_id: locationId } : {}),
      ...(typeof locationName !== 'undefined' ? { location_name: locationName } : {}),
    };
  }, [locationInfo]);

  const extractTitle = useCallback(() => {
    if (children.length === 0 || !children[0].props) return '';
    const { title, process } = children[0].props;
    if (typeof title === 'string') return title;
    if (title?.props?.children) {
      const titleChildren = title.props.children;
      if (Array.isArray(titleChildren)) {
        return titleChildren.filter(child => typeof child === 'string').join(' ');
      }
      if (typeof titleChildren === 'string') return titleChildren;
    }
    if (process && process.code) return `Process ${process.code}`;
    return '';

  }, [children]);

  // const isAgency = useMemo(() => {
  //   return auth.currentUser.role === userRole.AGENCY;
  // }, [auth]);

  useEffect(() => {
    if (Object.keys(mainMenu.items).length === 0) return;

    if (location?.state?.itemKey) {
      setCurrentPathKey(location.state.itemKey);
    } else if (mainMenu.byPath[location.pathname]) {
      setCurrentPathKey(mainMenu.byPath[location.pathname]);
    } else {
      setCurrentPathKey('');
    }
    setIsLoading(false);
  }, [location, mainMenu.items, mainMenu.byPath]);

  const pageTitle = extractTitle();
  usePageTitle(pageTitle);

  const onSelectedMenuItemChanged = useCallback(({ item }) => {
    if (item && item.props && item.props.path) {
      history.push(item.props.path, {
        state: {
          itemKey: item.props.eventKey,
        }
      });
    }
  }, [history]);

  return (
    <BaseLayout>
      <Sider theme="light" width={'250px'}>
        {!isLoading && (
          <SideNav
            menu={mainMenu.items}
            selectedMenuItemKey={currentPathKey}
            onSelectedMenuItemChanged={onSelectedMenuItemChanged}
            locationInfo={locationInfo}
          />
        )}
      </Sider>
      <Content>
        {children}
      </Content>
      {/* {showNotifications && !isAgency ? <NotificationToaster /> : null} */}
      {/* {chatIsVisible !== false && (
        <GenAgentChat
          baseUrl={process.env.REACT_APP_CHAT_API_URL}
          apiKey={process.env.REACT_APP_CHAT_API_KEY}
          metadata={chatMetadata}
          headerTitle={`${theme.companyName} Support`}
          placeholder="Ask anything..."
          theme={{
            primaryColor: theme.primaryColor,
            backgroundColor: "#ffffff",
            textColor: "#000000",
            fontFamily: "Roboto, Arial, sans-serif",
            fontSize: "14px",
          }}
          mode="floating"
          floatingConfig={{
            position: "bottom-right",
          }}
        />
      )} */}
    </BaseLayout>
  );
};

export default PrimaryLayout;
